import { render, staticRenderFns } from "./QuickSale.vue?vue&type=template&id=8a3cce2c&scoped=true"
import script from "./QuickSale.vue?vue&type=script&lang=js"
export * from "./QuickSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3cce2c",
  null
  
)

export default component.exports